import React from "react";
import BaggageSummary from "../components/BaggageSummary";
import "./BaggageAndFareSummary.css";

export default function BaggageAndFareSummary({ offer }) {
  const chips = offer?.baggage?.detailChips || offer?.baggage?.chips || [];
  return (
    <section className="fe2-bagfare">
      <h2 className="fe2-bagfare__title">מה כלול בכרטיס</h2>
      <BaggageSummary chips={chips} />
    </section>
  );
}
